import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import BeautyPreferencesSelector from 'selectors/beautyPreferences/beautyPreferencesSelector';
import BPUtils from 'utils/BeautyPreferences';
import Actions from 'Actions';

const { showInfoModal } = Actions;
const { beautyPreferencesSelector } = BeautyPreferencesSelector;

const { wrapHOC } = FrameworkUtils;
const getText = localeUtils.getLocaleResourceFile(
    'components/ProductPage/RatingsAndReviews/ReviewsFilters/BeautyPreferencesFilter/locales',
    'BeautyPreferencesFilter'
);

const bpFiltersCategoryMap = {
    cat140006: ['skinType', 'skinConcerns', 'skinTone', 'eyeColor', 'ageRange'], //makeup
    cat150006: ['skinType', 'skinConcerns', 'skinTone', 'ageRange'], //scincare
    cat130038: ['hairColor', 'hairType', 'hairConcerns', 'hairTexture'], //hair
    cat160006: ['fragrancePreferences'] //fragrance
};

const fields = createSelector(
    createStructuredSelector({
        beautyPreferences: localeUtils.getTextFromResource(getText, 'beautyPreferences'),
        modalTitle: localeUtils.getTextFromResource(getText, 'modalTitle'),
        modalBody: localeUtils.getTextFromResource(getText, 'modalBody'),
        buttonText: localeUtils.getTextFromResource(getText, 'buttonText')
    }),
    beautyPreferencesSelector,
    (_state, ownProps) => ownProps,
    (localization, beautyPreferences, ownProps) => {
        const { categoryId, reviewFilters } = ownProps;
        const refinementsByCategory = BPUtils.getMasterListRefinementsByCategory(categoryId);
        const categoryFilters = refinementsByCategory.filter(
            item => bpFiltersCategoryMap[categoryId].includes(item.key) && reviewFilters.find(filter => filter.id === item.key)
        );

        const filterOptions = {};

        categoryFilters.forEach(categoryFilter => {
            //get user selected BP for every category
            const userCategoryFilter = beautyPreferences.beautyPreferences[categoryFilter.key].filter(
                item => !/notSure|notSureSc|notSureHc/.test(item) //remove options that shouldn't be shown
            );

            //get filter values for every user BP filter from master list
            if (Array.isArray(userCategoryFilter)) {
                filterOptions[categoryFilter.key] = userCategoryFilter.map(item => {
                    return categoryFilter.items.find(filterOption => filterOption.key === item)?.value || '';
                });
            } else {
                filterOptions[categoryFilter.key] = [categoryFilter.items.find(item => item.key === userCategoryFilter)?.value || ''];
            }
        });

        const isNoOptions = Object.values(filterOptions).flat().length === 0;

        return {
            localization,
            filterOptions,
            isNoOptions
        };
    }
);

const functions = {
    showInfoModal
};

const withBeautyPreferencesFilterProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withBeautyPreferencesFilterProps
};
